import { memo } from "react";
import { Redirect, matchPath, useLocation } from "react-router";

import { getQueryStringValues, stringify } from "@tsp-features/query/utils";

import { SoulEntityContentType } from "@tsp-domains/soul-entities/enums";
import { SoulEntityContentUuid, SoulEntityOrderUuid } from "@tsp-domains/soul-entities/types";

type OrderMatchParams = {
  orderUuid: SoulEntityOrderUuid;
};

const ORDER_MATCH_PROPS = {
  path: "/manual-registration/order/:orderUuid",
};

type ContentMatchParams = {
  contentType: SoulEntityContentType;
  contentUuid: SoulEntityContentUuid;
};

const CONTENT_MATCH_PROPS = {
  path: "/manual-registration/content/:contentType/:contentUuid",
};

const root = `/work-registration`;

function ManualRegistrationPage() {
  const location = useLocation();

  const {
    order_uuid: orderUuid,
    content_type: contentType,
    content_uuid: contentUuid,
    content_uuids: contentUuids,
    prepared_result: preparedResult,
  } = getQueryStringValues(location.search, {
    order_uuid: null,
    content_type: null,
    content_uuid: null,
    prepared_result: null,
    content_uuids: null,
  });

  const query = stringify({ content_uuids: contentUuids, prepared_result: preparedResult });
  const search = query ? `?${query}` : query;

  const isCreatePage = matchPath(location.pathname, {
    path: "/manual-registration/create",
  });

  if (isCreatePage) {
    if (orderUuid) {
      return <Redirect to={`${root}/order/${orderUuid}/create${search}`} />;
    }

    if (contentType && contentUuid) {
      return <Redirect to={`${root}/content/${contentType}/${contentUuid}/create${search}`} />;
    }
  }

  const orderMatch = matchPath<OrderMatchParams>(location.pathname, ORDER_MATCH_PROPS);
  if (orderMatch) {
    return <Redirect to={`${root}/order/${orderMatch.params.orderUuid}`} />;
  }

  const contentMatch = matchPath<ContentMatchParams>(location.pathname, CONTENT_MATCH_PROPS);
  if (contentMatch) {
    return <Redirect to={`${root}/content/${contentMatch.params.contentType}/${contentMatch.params.contentUuid}`} />;
  }

  return <Redirect to={root} />;
}

export default memo(ManualRegistrationPage);
